import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import BootstrapVue from "bootstrap-vue";
import store from './store/store.js';
import Axios from "axios";

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap-vue/dist/bootstrap-vue.css"
import {
  ValidationObserver,
  ValidationProvider,
  extend,
  localize
} from "vee-validate";
import en from "vee-validate/dist/locale/en.json";
import * as rules from "vee-validate/dist/rules";

//https://www.npmjs.com/package/vue-confirm-dialog
import VueConfirmDialog from 'vue-confirm-dialog'

//https://github.com/LouisMazel/vue-phone-number-input
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';

// Install VeeValidate rules and localization
Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

localize("en", en);

Vue.config.productionTip = false;
Vue.prototype.$API_URL = 'https://tearcell.com/api/safeharbour/'

// Install VeeValidate components globally
Vue.component("ValidationObserver", ValidationObserver);
Vue.component("ValidationProvider", ValidationProvider);

Vue.component('vue-phone-number-input', VuePhoneNumberInput);

Vue.use(BootstrapVue);
Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)

Vue.prototype.$http = Axios;
const accessToken = localStorage.getItem('token');

if (accessToken) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = 'Token ' + accessToken;
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");